import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

const InvalidRecipientsTableHeader: FC = () => {
  const { t } = useTranslate();

  const columns = [
    { key: 'invalid-email', content: t('Email') },

    { key: 'invalid-name', content: t('Recipient') },

    { key: 'reason', content: t('Reason') },
  ] as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default InvalidRecipientsTableHeader;
